import type { Position } from "geojson";
import turfArea from "@turf/area";
import turfCentroid from "@turf/centroid";
import type { AnyPolygonFeature } from "../types";

/** Returns the geodesic area in square meters */
export function polygonArea(poly: AnyPolygonFeature): number {
	return turfArea(poly);
}

/** Returns the centroid [lng, lat] of a polygon */
export function polygonCentroid(poly: AnyPolygonFeature): Position {
	return turfCentroid(poly).geometry.coordinates;
}
